import React from 'react';
import { StepItem } from '../../../../../../components/Step';
import { Container, Ul, P, StepCopy, StepContentWrapper, Left, LeftContent, Right } from './styles';

const BatteryPix = props => (
    <Container>
        <Left>
            <LeftContent>
                {props.batteryPicture}
            </LeftContent>
        </Left>

        <Right>
            <Ul>
                <StepItem>
                    <StepContentWrapper>
                        <StepCopy>
                            <h1>{props.batteryName}</h1>
                            <P>
                                {props.batteryText}
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>
            </Ul>
        </Right>
    </Container>
);

export default BatteryPix;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/BatteryPix/BatteryPix.js